import { render, staticRenderFns } from "./ScripStudentModule.vue?vue&type=template&id=21366ae6&scoped=true"
import script from "./ScripStudentModule.vue?vue&type=script&lang=js"
export * from "./ScripStudentModule.vue?vue&type=script&lang=js"
import style0 from "./ScripStudentModule.vue?vue&type=style&index=0&id=21366ae6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21366ae6",
  null
  
)

export default component.exports